import { cn } from "@/lib/utils";
import { FONT_SIZE } from "@/utils/constants/size";
import { AppTheme } from "@/utils/constants/theme";
import React from "react";

export type TextSizeProps = "xs" | "sm" | "md" | "lg" | "xl";

export type TextProps = React.ComponentProps<"p"> & {
  color?: string;
  size?: TextSizeProps | number;
  bold?: boolean;
  lineDecoration?: React.CSSProperties["textDecorationLine"];
  position?: React.CSSProperties["textAlign"];
};

const Text = ({
  children,
  color = AppTheme.darkJungleGreen,
  size = "sm",
  lineDecoration = "none",
  position = "start",
  className,
  style,
  ...rest
}: TextProps) => {
  return (
    <p
      {...rest}
      className={cn(className)}
      style={{
        color,
        fontSize: typeof size === "number" ? `${size}px` : FONT_SIZE[size],
        textDecorationLine: lineDecoration,
        textAlign: position,
        ...style, // allow user-provided style overrides
      }}
    >
      {children}
    </p>
  );
};

export default Text;
